import { useState } from "react";
import MultipleChooseOption from "../../../../common/components/inputFields/multipleChooseOption/multipleChooseOption";
import { OptionModel } from "../../../createCampaign/models/questionModel";
import "./campaignMultipleChoose.scss";

export default function CampaignMultipleChoose(props: {
  border?: string;
  color?: string;
  fontFamily?: string;
  optionsData?: OptionModel[];
  onChange?: (e: OptionModel[]) => void;
}) {
  const [selectedOption, setSelectedOption] = useState<OptionModel[]>([]);
  return (
    <div className="campaign-multiple-choose">
      {props.optionsData?.map((e, i) => (
        <MultipleChooseOption
          key={i}
          initialValue={{ option: e.option }}
          viewOnly
          border={props.border ?? "2px solid rgba(255, 255, 255, 0.5)"}
          color={props.color ?? "rgba(255, 255, 255, 1)"}
          fontFamily={props.fontFamily}
          isSelected={selectedOption.includes(e)}
          onClick={() => {
            if (selectedOption.includes(e)) {
              let temp = [...selectedOption];
              temp = temp.filter((e2) => e2 != e);
              setSelectedOption(temp);
              props.onChange?.(temp);
            } else {
              setSelectedOption([...selectedOption, e]);
              props.onChange?.([...selectedOption, e]);
            }
          }}
        />
      ))}
    </div>
  );
}
